export const deviceSelectionLimit = 20;
export const DEFAULT_PARKED_CALL_RING_BACK_TIME = 30;
export const DEFAULT_PAGE_SIZE = 10;
